import React from 'react'
import styled from "styled-components";

const Separator = styled.div`
    height: 1px;
    background: #e3e3e3;
`

const SeparatorComponent = (props) => {
    return <Separator/>
}

export default SeparatorComponent;